export default (name: string, data?: Object) => {
    try {
        if(typeof window.gtag !== 'function') {
            return
        }
        window.gtag('event', name, data || {})
    } catch(error) {
        console.error(error)
    }
}